import { getImage, getGatewayCampaigns } from "../api/dataFactory";

const homepageMixins = device => ({
  data: () => ({
    campaigns: [],
    getImage
  }),

  created() {
    this.getCampaigns({ device: device });
  },

  methods: {
    async getCampaigns(requestParams) {
      this.campaigns = await getGatewayCampaigns(requestParams);
    },
    filterCampaignBySpot(spot) {
      return this.campaigns != undefined
        ? this.campaigns.filter(campaigns => campaigns.spot.includes(spot))
        : [];
    },
    parseMetadata(metadata) {
      return JSON.parse(metadata);
    }
  },

  computed: {
    topCampaigns() {
      return this.filterCampaignBySpot("top-campaign-carousel");
    },
    bestSellerCampaignProducts() {
      return this.filterCampaignBySpot("bestseller-campaign");
    },
    newReleasesCampaignProducts() {
      return this.filterCampaignBySpot("new-release-campaign");
    }
  }
});

export default homepageMixins;
